// PWA Service Worker Registration
// Registers service worker for PWA installability & offline capabilities
export function register() {
  if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
      const publicUrl = process.env.PUBLIC_URL || '';
      const swUrl = `${publicUrl}/service-worker.js`;

      navigator.serviceWorker
        .register(swUrl)
        .then((registration) => {
          console.log('✅ PWA Service Worker registered:', registration.scope);

          registration.onupdatefound = () => {
            const installingWorker = registration.installing;
            if (installingWorker == null) return;
            installingWorker.onstatechange = () => {
              if (installingWorker.state === 'installed') {
                if (navigator.serviceWorker.controller) {
                  console.log('🔄 New PWA content available; please refresh.');
                } else {
                  console.log('⚡ PWA cached for offline use.');
                }
              }
            };
          };
        })
        .catch((error) => {
          console.warn('PWA Service Worker registration note:', error?.message);
        });
    });
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (const registration of registrations) {
        registration.unregister();
      }
    });
  }
}
